const NameFormatter = (name) => {
	if(name === 'doubleunders') return 'Double Unders';
	if(name === 'situps') return 'Sit-ups';
	if(name === 'pushups') return 'Push-ups';
	if(name === 'kbswings') return 'KB Swings';
	if(name === 'pullups') return 'Pull-ups';
	return name;
}

export default NameFormatter;